module.exports = __webpack_public_path__ + "static/media/commission-icon-active.99dc249f.svg";